import * as Types from '../types';

interface UserProfileUpdates {
  firstname?: string;
  lastname?: string;
  countryCode?: string;
}

interface UpdateUserProfileAction {
  type: string;
  payload: { userId: string; updates: UserProfileUpdates };
}

interface UpdateUserProfileSuccessAction {
  type: string;
  payload: { user: unknown };
}

interface UpdateUserProfileFailureAction {
  type: string;
  payload: { error: unknown };
}

interface ChangeUserPasswordAction {
  type: string;
  payload: { userId: string; currentPassword: string; newPassword: string };
}

interface ChangeUserPasswordSuccessAction {
  type: string;
}

interface ChangeUserPasswordFailureAction {
  type: string;
  payload: { error: unknown };
}

/**
 * Update user profile fields (firstname, lastname, countryCode)
 */
export const updateUserProfile = (
  userId: string,
  updates: UserProfileUpdates,
): UpdateUserProfileAction => ({
  type: Types.UPDATE_USER_PROFILE,
  payload: { userId, updates },
});

export const updateUserProfileSuccess = (user: unknown): UpdateUserProfileSuccessAction => ({
  type: Types.UPDATE_USER_PROFILE_SUCCESS,
  payload: { user },
});

export const updateUserProfileFailure = (error: unknown): UpdateUserProfileFailureAction => ({
  type: Types.UPDATE_USER_PROFILE_FAILURE,
  payload: { error },
});

/**
 * Change user password
 */
export const changeUserPassword = (
  userId: string,
  currentPassword: string,
  newPassword: string,
): ChangeUserPasswordAction => ({
  type: Types.CHANGE_USER_PASSWORD,
  payload: { userId, currentPassword, newPassword },
});

export const changeUserPasswordSuccess = (): ChangeUserPasswordSuccessAction => ({
  type: Types.CHANGE_USER_PASSWORD_SUCCESS,
});

export const changeUserPasswordFailure = (error: unknown): ChangeUserPasswordFailureAction => ({
  type: Types.CHANGE_USER_PASSWORD_FAILURE,
  payload: { error },
});
